import * as React from 'react'

const ArrowDown = (props: { className: string; onClick?: (e: any) => void }) => (
  <svg
    onClick={props.onClick}
    className={'icon ' + props.className}
    viewBox='0 0 11 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity='0.262'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.28333 0L5.5 4.35135L9.71667 0L11 1.32432L5.5 7L0 1.32432L1.28333 0Z'
      fill='#000'
    />
  </svg>
)

export default ArrowDown



// WEBPACK FOOTER //
// ./src/components/icons/ui/ArrowDown.tsx